import { StoryPage } from './StoryPage'
import { withStoryPage } from './withStoryPage'

const ConnectedStoryPage = withStoryPage(StoryPage)

export { ConnectedStoryPage as StoryPage }
